<template>
  <div class="FotterWrapper">
    <div class="fotterTop">
      <div class="left">
        <div class="name">川渝地方文献目录检索平台</div>
        <div class="views">地址：重庆市巴南区文化艺术中心</div>
        <div class="views">电话：023-66223062</div>
      </div>
      <div class="middle">
        <div class="name">友情链接</div>
        <ul class="linkList" v-if="linkList.length>0">
          <li v-for="(items,index) of $group(linkList,2)" :key="index">
            <template v-if="items.length>0">
              <a :href="item.url" 
                v-for="(item,key) of items" 
                target="_blank" 
                :key="key" 
                class="views"
                :title="item.title" >{{item.title}}</a>
            </template>
          </li>
        </ul>
      </div>
      <div class="right">
        <ul class="codeList" >
          <li >
            <p></p>
            <div class="imgCode">
              <img src="/static/images/codeImg.jpg" alt="">
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="copyright">Copyright @
      &nbsp;&nbsp;&nbsp;&nbsp;
      <a href="http://www.bnszwhw.cn/" target="_blank">重庆市巴南区图书馆版权所有</a>
      &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="JavaScript:;" >渝ICP备07006992号-5</a>
      &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <a href="http://www.yunlib.cn/" target="_blank">技术支持：四川云图</a>
    </div>
  </div>
</template>
<script>
export default {
  name:"Fotter",
  data() {
    return {
      linkList:[
        {
          url:"http://www.bnszwhw.cn/",
          title:"重庆市巴南区图书馆"
        },
       
      ],
      codeList:[
        {
          img:"static/images/codeImg.jpg"
        },
      ]
    }
  },
}
</script>
<style lang="scss" scope>
  .FotterWrapper{
    width: 100%;
    height: 200px;
    // position: fixed;
    background: url(/static/images/pc-fotter.jpg) no-repeat;
    background-size: 100% 200px;
    left: 0;
    bottom: 0;
    .fotterTop{
      width: 100%;
      height: 155px;
      overflow: hidden;
      display: flex;
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      .left{
        width: 340px;
      }
      .middle{
        width: 475px;
      }
      .right{
        width: 215px;
      }
      .name{
        height: 56px;
        line-height: 56px;
        padding-top: 10px;
        color: nth($list: $default, $n: 1);
      }
      .views{
        display: block;
        height: 36px;
        line-height: 36px;
        font-size: nth($list: $size, $n: 3);
        color: nth($list: $sort, $n: 3);
        @extend %sin;
      }
      .linkList{
        display: flex;
        flex-wrap: nowrap;
        .views{
          width: 160px;
          margin-right: 15px;
          &:hover{
            color: $success;
          }
        }
      }
      .codeList{
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        width: 215px;
        p{
          text-align: center;
          line-height: 52px;
          height: 52px;
          padding-top: 10px;
          color: nth($list: $default, $n: 1);
          font-size: nth($list: $size, $n: 4);
        }
        .imgCode{
          width: 80px;
          height: 80px;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .copyright{
      height: 45px;
      line-height: 45px;
      font-size: nth($list: $size, $n: 5);
      width: 100%;
      text-align: center;
      color: nth($list: $minor, $n: 2);
      *{
        color: nth($list: $minor, $n: 2);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/DefaultFotter.vue